/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Cover_HeadlineInputs */

const en_us2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Your month`);
	return /** @type {LocalizedString} */ (`Your year`)
	
};

const pt_br2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Seu mês`);
	return /** @type {LocalizedString} */ (`Seu ano`)
	
};

const es_419_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Tu mes`);
	return /** @type {LocalizedString} */ (`Tu año`)
	
};

const pt_pt2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O teu mês`);
	return /** @type {LocalizedString} */ (`O teu ano`)
	
};

const fr_fr2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ton mois`);
	return /** @type {LocalizedString} */ (`Ton année`)
	
};

const de_de2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Dein Monat`);
	return /** @type {LocalizedString} */ (`Dein Jahr`)
	
};

const it_it2_wrapped_period_cover_headline = /** @type {(inputs: Wrapped_Period_Cover_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Il tuo mese`);
	return /** @type {LocalizedString} */ (`Il tuo anno`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Your month" |
* | * | "Your year" |
*
* @param {Wrapped_Period_Cover_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_cover_headline = /** @type {((inputs: Wrapped_Period_Cover_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Cover_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_cover_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_period_cover_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_cover_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_cover_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_cover_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_cover_headline(inputs)
	return en_us2_wrapped_period_cover_headline(inputs)
});
export { wrapped_period_cover_headline as "wrapped-period.cover_headline" }